<template>
  <div v-if="$route.name!='maintenance'">
    <div
      class="modal is-active"
      v-if="isiOS && showInstallDialog"
      id="installHomeScreenModal"
      style="z-index:99999;"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">App installieren</p>
          <button
            class="delete"
            aria-label="close"
            @click="$store.commit('showInstallDialog', false)"
          ></button>
        </header>
        <section class="modal-card-body has-text-centered">
          <p>
            <img
              src="/img/icons/apple-touch-icon-76x76.png"
              style="border-radius: 15px;animation: shakeIcon .4s;animation-iteration-count: infinite;"
            >
          </p>
        </section>
        <footer class="modal-card-foot has-text-centered">
          <p>
            Tippen Sie zum Installieren zuerst auf
            <img
              src="/img/icons/Navigation_Action_2x.png"
              style="width:12px;height:17px;margin-right:5px;margin-left:5px;"
            > und dann auf
            <strong>Zum Home-Bildschirm</strong>.
          </p>
        </footer>
      </div>
    </div>

    <nav
      class="navbar is-fixed-top"
      style="background-image: url(https://assets.urlaubimwaldviertel.at/images/8870-urlaub-im-waldviertel-logo.png);background-repeat: no-repeat;background-size: 520px 52px;"
    >
      <span
        tag="span"
        v-if="filterContent"
        class="tooltip tt-info content is-small has-text-centered"
      >
        <span class="icon">
          <i class="fa fa-check"></i>
        </span>Filter
        <a @click="filter">Aus</a>&nbsp;
      </span>

      <div class="navbar-brand">
        <a @click="$router.go(-1)" class="navbar-item no-hover" v-if="$route.name!='home'">
          <span class="icon">
            <i class="fa fa-arrow-left"></i>
          </span>
        </a>

        <router-link
          to="/"
          class="navbar-item no-hover"
          style="color: transparent;"
        >urlaubimwaldviertel.at</router-link>

        <div
          class="navbar-burger burger"
          data-target="navMenuTransparentExample"
          @click="showBurger = !showBurger"
          :class="{ 'is-active' : showBurger }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div id="navMenuTransparentExample" class="navbar-menu" :class="{ 'is-active' : showBurger }">
        <div class="navbar-end">
          <router-link class="navbar-item" to="/ausflugsziele" @click.native="showMenue">
            <span class="icon">
              <i class="fas fa-map-signs" style="color: #209cee;"></i>
            </span>
            <span>&nbsp;Ausflugsziele</span>
          </router-link>
          <router-link class="navbar-item" to="/kulinarium" @click.native="showMenue">
            <span class="icon">
              <i class="fas fa-utensils" style="color: #e6194b;"></i>
            </span>
            <span>&nbsp;Kulinarium</span>
          </router-link>
          <router-link class="navbar-item" to="/unterkuenfte" @click.native="showMenue">
            <span class="icon">
              <i class="fas fa-bed" style="color: #ffdd57;"></i>
            </span>
            <span>&nbsp;Unterkünfte</span>
          </router-link>
          <a
            class="navbar-item"
            href="https://www.facebook.com/urlaubimwaldviertel.at"
            target="_blank"
          >
            <span class="icon" style="color: #3B5998;">
              <i class="fab fa-lg fa-facebook-square"></i>
            </span>
            <span class="is-hidden-desktop">&nbsp;/urlaubimwaldviertel.at</span>
          </a>
        </div>
      </div>
    </nav>

    <nav
      class="navbar is-fixed-top has-shadow is-light search-bar is-hidden-desktop"
      v-if="$route.name=='home'"
    >
      <div class="navbar-brand">
        <div class="container" style="width: 100vw; max-width: none;">
          <locationSearch></locationSearch>
        </div>
      </div>
    </nav>

    <nav
      class="navbar is-fixed-top has-shadow is-dark"
      v-if="userIsAuthenticated"
      style="bottom: 0; top: auto;"
    >
      <div class="navbar-brand">
        <router-link to="/cms/create" title="Neu" class="navbar-item">
          <span class="icon">
            <i class="fas fa-plus-square"></i>
          </span>
        </router-link>
        <router-link to="/cms/list" title="Liste" class="navbar-item">
          <span class="icon">
            <i class="fas fa-align-justify"></i>
          </span>
        </router-link>
        <router-link to="/cms/files" title="Dateien" class="navbar-item">
          <span class="icon">
            <i class="fas fa-folder-open"></i>
          </span>
        </router-link>
        <a @click="onLogout" title="Logout" class="navbar-item" v-if="userIsAuthenticated">
          <span class="icon">
            <i class="fas fa-sign-out-alt"></i>
          </span>
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
import locationSearch from './shared/LocationSearch.vue'
export default {
  data() {
    return {
      showBurger: false
    }
  },
  computed: {
    userIsAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    cookies_maps() {
      return this.$store.getters.cookies_maps
    },
    filterContent() {
      return this.$store.getters.filterContent
    },
    isiOS() {
      return this.$store.getters.isiOS
    },
    showInstallDialog() {
      return this.$store.getters.showInstallDialog
    }
  },
  methods: {
    filter() {
      this.$store.dispatch('filterContent')
    },
    onLogout() {
      this.$store.commit('LOGOUT_USER')
      this.$router.push('/Login')
    },
    showMenue() {
      this.showBurger = !this.showBurger
    }
  },
  components: {
    locationSearch
  }
}
</script>

<style scoped>
.search-bar {
  margin-top: 52px;
  z-index: 29 !important;
  height: 40px !important;
}

.no-hover:hover {
  color: white;
  background-color: transparent;
}
</style>
